import { Pipe, PipeTransform } from '@angular/core';
import { ReportGroup } from '../../_models/reports';

@Pipe({ name: 'reportGroupQueryFilter' })

export class ReportGroupQueryFilterPipe implements PipeTransform {
  transform(reportGroups: ReportGroup[], queryText: string, updateNumber?: number): any[] {
    if (!reportGroups) return [];
    if (!queryText) return reportGroups;
    queryText = queryText.trim().toLowerCase();
    return reportGroups.filter(reportGroup => {
      if (reportGroup.reportGroup.toLowerCase().includes(queryText)) {
        return reportGroup;
      }
      for (var i = 0; i < reportGroup.reports.length; i++) {
        if (reportGroup.reports[i].reportName.toLowerCase().includes(queryText)) {
          return reportGroup;
        }
      }
    });
  }
}
